// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleShare_wrapper__obLfN","shareList":"ArticleShare_shareList__tAwW_"};